// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-elements header {\n  margin-bottom: 24px !important;\n}\n.search-elements header input {\n  margin-top: 14px;\n}\n.search-elements .row.margin-bottom-30 {\n  margin: 0 0 30px 0;\n}\n", ""]);
// Exports
module.exports = exports;
